import { createApiHandler } from './handler';

const quoteRequests = {
  apiClient: null,
  path: '/admin/quote-requests',

  setClient(apiClient) {
    this.apiClient = apiClient;
    this.initApiHandler();
  },

  initApiHandler() {
    Object.assign(this, createApiHandler(this.apiClient, this.path));
  },

  async reject(id, form) {
    try {
      const response = await this.apiClient.post(`${this.path}/${id}/reject`, form);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async confirmNoChange(id, form) {
    try {
      const response = await this.apiClient.post(`${this.path}/${id}/confirm-no-change`, form);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export default quoteRequests;
